import { DRAWER_WIDTH } from "@/constants/layout";
import { Header, Menu } from "@/organism";
import { Box, Drawer, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import useLayout from "./useLayout";

export const Layout = () => {
  const {
    container,
    mobileOpen,
    handleDrawerClose,
    handleDrawerTransitionEnd,
    handleDrawerToggle,
    username,
  } = useLayout();

  return (
    <Box display={"flex"}>
      <Header onDrawerToggle={handleDrawerToggle} username={username} />
      <Box
        component={"nav"}
        sx={{ width: { md: DRAWER_WIDTH }, flexShrink: { md: 0 } }}
      >
        <Drawer
          container={container}
          variant={"temporary"}
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: {
              xs: "block",
              md: "none",
            },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: DRAWER_WIDTH,
              borderRight: "none",
            },
          }}
        >
          <Menu />
        </Drawer>
        <Drawer
          variant="permanent"
          open
          sx={{
            display: {
              xs: "none",
              md: "block",
            },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: DRAWER_WIDTH,
              // backgroundColor: theme.palette.primary.main,
              // borderRight: 'none',
            },
          }}
        >
          <Menu />
        </Drawer>
      </Box>
      <Box
        component={"main"}
        sx={{
          flexGrow: 1,
          width: {
            md: `calc(100% - ${DRAWER_WIDTH}px)`,
          },
        }}
      >
        <Toolbar />
        <Box component={"div"} sx={{ p: 4 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};
